import { DeliveryCompaniesService } from '@/core/services/delivery-companies.service'

import {
    DeliveryCompanyPayload,
    GetBillingDeliveryCompaniesParams,
    GetBillingDeliveryCompaniesResponse,
    GetDeliveryCompaniesParams,
    GetDeliveryCompaniesResponse,
    GetDeliveryCompanyResponse,
} from '@/core/types/delivery-companies.types'

const deliveryCompaniesService = new DeliveryCompaniesService()

class DeliveryCompaniesRealisation {
    getCompanies(params: GetDeliveryCompaniesParams): Promise<GetDeliveryCompaniesResponse> {
        return deliveryCompaniesService.getCompanies(params)
    }

    getCompany(company_id: number): Promise<GetDeliveryCompanyResponse> {
        return deliveryCompaniesService.getCompany(company_id)
    }

    createCompany(payload: FormData): Promise<void> {
        return deliveryCompaniesService.createCompany(payload)
    }

    updateCompany(company_id: number, payload: DeliveryCompanyPayload): Promise<void> {
        return deliveryCompaniesService.updateCompany(company_id, payload)
    }

    deleteCompany(company_id: number): Promise<void> {
        return deliveryCompaniesService.deleteCompany(company_id)
    }

    getBillingCompanies(
        params: GetBillingDeliveryCompaniesParams
    ): Promise<GetBillingDeliveryCompaniesResponse> {
        return deliveryCompaniesService.getBillingCompanies(params)
    }
}

export const deliveryCompanies = new DeliveryCompaniesRealisation()
